/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Divider, Stack } from "@mui/material";

/**
 * @param {Object} props 
 * @param {import("react").ReactNode} props.children
 */
const ToolbarRow = (props) => {
    
    const { children } = props;
    return (
        <Stack
            direction='row'
            sx={{ cursor: "auto", mx: "0.5rem", backgroundColor: "#fff" }}
            flexWrap='wrap'
            divider={<Divider orientation='vertical' flexItem />}
        >
            {children}
        </Stack>
    );
};
export { ToolbarRow };
